import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Alert, Button, Heading } from '@innovationnorway/cl-react';
import { OneWayInServiceProviderDto } from 'src/api/v2';
import ChooseActor, { ActorFilters } from '../ChooseActor';

interface SelectActorStepProps {
  formId: string | undefined;
  searchQuery: string;
  setSearchQuery: (value: React.SetStateAction<string>) => void;
  selectedActorRows: OneWayInServiceProviderDto[];
  setSelectedActorRows: React.Dispatch<React.SetStateAction<OneWayInServiceProviderDto[]>>;
  filters: ActorFilters;
  setFilters: React.Dispatch<React.SetStateAction<ActorFilters>>;
  onNext: () => void;
}

const SelectActorStep = ({
  formId,
  searchQuery,
  setSearchQuery,
  selectedActorRows,
  setSelectedActorRows,
  filters,
  setFilters,
  onNext,
}: SelectActorStepProps) => {
  const { t: tCommon } = useTranslation();
  const { t: tOneWayIn } = useTranslation('oneWayIn');

  const [showError, setShowError] = useState(false);

  return (
    <>
      <Heading level={2} className="refer-dialog--heading">
        {tOneWayIn('actionbar.Refer')}
      </Heading>
      <div className="refer-dialog--layout refer-dialog--min-height-choose-actor">
        <div className="refer-dialog--body">
          <span>{tOneWayIn('refer.dialog.selectActor')}</span>
          <div className="refer-dialog--compact-table">
            <ChooseActor
              formId={formId}
              searchQuery={searchQuery}
              setSearchQuery={setSearchQuery}
              selectedActors={selectedActorRows}
              setSelectedRows={setSelectedActorRows}
              filters={filters}
              setFilters={setFilters}
            />
          </div>
        </div>
        {selectedActorRows.length === 0 && showError && (
          <div className="margin-top--ds-3">
            <Alert data-color="danger" className="dialog-with-sidebar--alert">
              {tOneWayIn('refer.validation.noActorChosen')}
            </Alert>
          </div>
        )}
        <div className="refer-dialog--action-row">
          <Button
            onClick={() => {
              if (selectedActorRows.length === 0) {
                setShowError(true);
                return;
              }
              setShowError(false);
              onNext();
            }}
          >
            {tCommon('next')}
          </Button>
        </div>
      </div>
    </>
  );
};

export default SelectActorStep;
